import { c as _c } from "react/compiler-runtime";
import { IcoCopy16 } from '@onefootprint/icons';
import type { GraphOperationRemoveNode } from '@onefootprint/request-types/dashboard';
import { Dropdown, useToast } from '@onefootprint/ui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withSubject } from '@/components/playbook-builder/utils/get-subject';
import useSession from '@/hooks/use-session';
import useStore from '../../hooks/use-store';
type CopyItemProps = {
  id: string;
  onClick: () => void;
};
const CopyItem = t0 => {
  const $ = _c(45);
  const {
    id,
    onClick
  } = t0;
  const {
    toast
  } = useToast();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "edit.copyNode"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const {
    data: session
  } = useSession();
  const {
    setNodeHighlight,
    data: t2
  } = useStore();
  const {
    graph
  } = t2;
  let t3;
  if ($[1] !== setNodeHighlight) {
    t3 = () => () => setNodeHighlight(undefined);
    $[1] = setNodeHighlight;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  useEffect(t3, t4);
  let nodeIdsToCopy;
  let nodesToCopy;
  let t5;
  if ($[4] !== graph || $[5] !== id) {
    let t6;
    if ($[9] !== id) {
      t6 = op => op.kind === "remove_node" && op.nodeId === id;
      $[9] = id;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    const removeOperation = graph.availableOperations.find(t6);
    nodeIdsToCopy = removeOperation?.nodeIdsToDelete ?? [id];
    let t7;
    if ($[11] !== graph) {
      t7 = node_1 => withSubject(graph)(node_1);
      $[11] = graph;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    nodesToCopy = graph.nodes.filter(node => nodeIdsToCopy.includes(node.id)).map(_temp).map(t7);
    t5 = nodesToCopy.filter(_temp2).some(n => !nodesToCopy.some(jp => jp.kind === "join_point" && jp.splitNodeId === n.id));
    $[4] = graph;
    $[5] = id;
    $[6] = nodeIdsToCopy;
    $[7] = nodesToCopy;
    $[8] = t5;
  } else {
    nodeIdsToCopy = $[6];
    nodesToCopy = $[7];
    t5 = $[8];
  }
  const isMissingJoinPoint = t5;
  if (isMissingJoinPoint) {
    return null;
  }
  let t6;
  if ($[13] !== nodesToCopy || $[14] !== onClick || $[15] !== t || $[16] !== toast) {
    t6 = () => {
      onClick();
      navigator.clipboard.writeText(JSON.stringify(nodesToCopy, null, 2));
      const description = nodesToCopy.length > 1 ? t(_temp3) : t(_temp4);
      toast({
        title: t(_temp5),
        description
      });
    };
    $[13] = nodesToCopy;
    $[14] = onClick;
    $[15] = t;
    $[16] = toast;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const handleCopy = t6;
  const showCopySingleNode = session.user?.isFirmEmployee && nodesToCopy.length > 1;
  let t7;
  if ($[18] !== id || $[19] !== nodesToCopy || $[20] !== onClick || $[21] !== t || $[22] !== toast) {
    t7 = () => {
      onClick();
      const nodeToCopy = nodesToCopy.filter(node_3 => node_3.id === id);
      navigator.clipboard.writeText(JSON.stringify(nodeToCopy, null, 2));
      const description_0 = nodesToCopy.length > 1 ? t(_temp6) : t(_temp7);
      toast({
        title: t(_temp8),
        description: description_0
      });
    };
    $[18] = id;
    $[19] = nodesToCopy;
    $[20] = onClick;
    $[21] = t;
    $[22] = toast;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  const handleCopySingleNode = t7;
  let t8;
  if ($[24] !== nodeIdsToCopy || $[25] !== setNodeHighlight) {
    t8 = () => setNodeHighlight({
      color: "info",
      ids: nodeIdsToCopy
    });
    $[24] = nodeIdsToCopy;
    $[25] = setNodeHighlight;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== setNodeHighlight) {
    t9 = () => setNodeHighlight(undefined);
    $[27] = setNodeHighlight;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t) {
    t10 = t(_temp9);
    $[29] = t;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== handleCopy || $[32] !== t10 || $[33] !== t8 || $[34] !== t9) {
    t11 = <Dropdown.Item iconLeft={IcoCopy16} onSelect={handleCopy} onMouseEnter={t8} onMouseLeave={t9}>{t10}</Dropdown.Item>;
    $[31] = handleCopy;
    $[32] = t10;
    $[33] = t8;
    $[34] = t9;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== handleCopySingleNode || $[37] !== id || $[38] !== setNodeHighlight || $[39] !== showCopySingleNode || $[40] !== t) {
    t12 = showCopySingleNode && <Dropdown.Item iconLeft={IcoCopy16} onSelect={handleCopySingleNode} onMouseEnter={() => setNodeHighlight({
      color: "info",
      ids: [id]
    })} onMouseLeave={() => setNodeHighlight(undefined)}>{t(_temp10)}</Dropdown.Item>;
    $[36] = handleCopySingleNode;
    $[37] = id;
    $[38] = setNodeHighlight;
    $[39] = showCopySingleNode;
    $[40] = t;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  let t13;
  if ($[42] !== t11 || $[43] !== t12) {
    t13 = <>{t11}{t12}</>;
    $[42] = t11;
    $[43] = t12;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  return t13;
};
export default CopyItem;
function _temp(t0) {
  const {
    context: _,
    ...node_0
  } = t0;
  return node_0;
}
function _temp2(node_2) {
  return node_2.kind === "conditional" || node_2.kind === "branch";
}
function _temp3($) {
  return $.toast.descriptionMultiple;
}
function _temp4($_0) {
  return $_0.toast.descriptionSingle;
}
function _temp5($_1) {
  return $_1.toast.title;
}
function _temp6($_2) {
  return $_2.toast.descriptionMultiple;
}
function _temp7($_3) {
  return $_3.toast.descriptionSingle;
}
function _temp8($_4) {
  return $_4.toast.title;
}
function _temp9($_5) {
  return $_5.label;
}
function _temp10($_6) {
  return $_6.labelSingleNode;
}